var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"app-header"},[_c('app-icon',{staticClass:"app-header__logo",attrs:{"icon":"icon-logo","size":"custom"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }